import { z } from 'zod';
import { athenaConversationActionSchema } from './conversation.js';

/** Discovery clarify branch — drives adaptive replies, not booking selection. */
export const athenaDiscoveryClarifyKindSchema = z.enum([
  'direction',
  'face_concern',
  'body_concern',
  'massage_goal',
  'safety_profile',
]);
export type AthenaDiscoveryClarifyKind = z.infer<typeof athenaDiscoveryClarifyKindSchema>;

/** Meta-answer branch for catalog overview / price questions. */
export const athenaDiscoveryAnswerKindSchema = z.enum(['overview', 'price']);
export type AthenaDiscoveryAnswerKind = z.infer<typeof athenaDiscoveryAnswerKindSchema>;

/** Discovery presentation phase — drives guided panels/chips, not booking FSM step. */
export const athenaDiscoveryPresentationKindSchema = z.enum([
  'clarify',
  'safety_gate',
  'safety_ask',
  'safety_details',
  'recommendation',
  'offer',
]);
export type AthenaDiscoveryPresentationKind = z.infer<typeof athenaDiscoveryPresentationKindSchema>;

/**
 * Typed SSOT for AI discovery decision metadata exposed via conversation response.
 * Stored at fsmSnapshot.athenaDecision — separate from strict athenaMemory.
 */
export const athenaDiscoveryDecisionStateSchema = z
  .object({
    action: athenaConversationActionSchema,
    clarifyKind: athenaDiscoveryClarifyKindSchema.optional(),
    answerKind: athenaDiscoveryAnswerKindSchema.optional(),
    presentationKind: athenaDiscoveryPresentationKindSchema.optional(),
  })
  .strict();

export type AthenaDiscoveryDecisionState = z.infer<typeof athenaDiscoveryDecisionStateSchema>;
